import React, { ReactElement } from 'react';
import { IconButton } from '../../../../../../components/CiscoUi';
import { Actions } from '../../../../../../components/Actions';

interface NetworkTableActionsProps {
  onDeleteClick: VoidFunction;
}

export function NetworkTableActions({
  onDeleteClick,
}: NetworkTableActionsProps): ReactElement {
  return (
    <Actions>
      <IconButton
        icon="trash"
        type="button"
        colour="link"
        onClick={onDeleteClick}
      />
    </Actions>
  );
}
